module.exports = __webpack_public_path__ + "img/businessLicenseUrl.920da1fa.png";